<script lang="ts" setup>
import { ref, onMounted } from 'vue'
import type { TabsPaneContext } from 'element-plus'
import { useAccountStore } from '@/stores/setting/Account'
import { User, Lock, EditPen } from '@element-plus/icons-vue'
import { storeToRefs } from 'pinia'
import ElFormAccount from './components/ElForm/ElFormAccount.vue'
import { useDateFormat } from '@/composables/userDateFormat'
import { useAuth } from 'auth-package'

const activeName = ref('first')
const accountStore = useAccountStore()
const { fullName, userCredentialsMetaData } = storeToRefs(accountStore)

onMounted(async () => {
    await Promise.all([accountStore.getUserAccount(), accountStore.getUserCredentials()])
})

/**
 * Handle tab click
 *
 * @param tab
 * @param event
 */
function handleTabClick(tab: TabsPaneContext, event: Event) {
    console.log(tab, event)
}

/**
 * Handle update button click
 */
function handleUpdateButtonClick() {
    const { login } = useAuth().getKeycloakInstance()
    login({ action: 'UPDATE_PASSWORD' })
}
</script>

<template>
    <el-card shadow="never">
        <el-row :gutter="20">
            <el-col :xs="24" :sm="7" :md="5" :lg="5">
                <div class="mb-5 ms-auto me-auto text-center">
                    <el-avatar
                        :size="128"
                        src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"
                    />
                    <div class="mt-2">{{ fullName }}</div>
                </div>
            </el-col>
            <el-col :xs="24" :sm="17" :md="19" :lg="19">
                <el-tabs v-model="activeName" @tab-click="handleTabClick" tab-position="top">
                    <el-tab-pane name="first">
                        <template #label>
                            <span class="tabs-label">
                                <el-icon><User /></el-icon>
                                <span>{{ $t('settings.personalDetails') }}</span>
                            </span>
                        </template>
                        <div class="mt-2">
                            <ElFormAccount />
                        </div>
                    </el-tab-pane>
                    <el-tab-pane name="second">
                        <template #label>
                            <span class="tabs-label">
                                <el-icon><Lock /></el-icon>
                                <span>{{ $t('settings.password') }}</span>
                            </span>
                        </template>
                        <div class="password-list pt-2">
                            <template
                                v-for="(userCredentialMetaData, index) in userCredentialsMetaData"
                                :key="index"
                            >
                                <el-space
                                    style="width: 100%"
                                    alignment="center"
                                    :fill-ratio="20"
                                    fill
                                >
                                    <div>{{ userCredentialMetaData.credential.userLabel }}</div>
                                    <div>
                                        {{ $t('settings.created') }}

                                        {{
                                            useDateFormat(
                                                userCredentialMetaData.credential.createdDate,
                                                'MMM DD, YYYY [at] HH:mm A'
                                            )
                                        }}
                                    </div>
                                    <div class="text-end">
                                        <el-button
                                            @click="handleUpdateButtonClick"
                                            :icon="EditPen"
                                            text
                                        >
                                            {{ $t('settings.update') }}
                                        </el-button>
                                    </div>
                                </el-space>
                                <el-divider />
                            </template>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </el-col>
        </el-row>
    </el-card>
</template>

<style lamg="scss" scoped>
.tabs-label {
    display: flex;
    align-items: center;
    gap: 0.25rem;
}

.password-list {
    font-size: 14px;
}
</style>
